import {forEach} from 'lodash';
import {AccountingConfig} from "./run/accountingConfig";
import {tawkChat} from "./run/chat";

const initialization = [
    AccountingConfig,
    tawkChat,
];

export const AppRun = {
    init: () => forEach(initialization, (init) => {
        init();
    })
};
